import React from 'react';
import PropTypes from 'prop-types';
import DateSwitcher from '../../../common/DateSwitcher';
import SimpleHeader from '../../headers/simpleHeader';
import DatePicker from '../../../common/DatePickerV2';
import EditTimeTrackingEntry from '../containers/EditTimeTrackingEntry';
import AddTimeTrackingEntry from '../containers/AddTimeTrackingEntry';

const EditTimeTracking = ({
  setCurrentDate,
  currentDate,
  extendedHourlyWages,
  totalTime,
  entries,
  barberId,
  canEditTimeTracking,
}) => (
  <div className="u-color-white u-p u-max-width-1000">
    <SimpleHeader heading="Barber time tracking" />
    <div className="layout layout--middle">
      <div className="layout__item u-7/20">
        <DatePicker
          component="button"
          onChange={setCurrentDate}
          value={currentDate}
          iconSize="medium"
          buttonType="blank"
        />
      </div>
      <div className="layout__item u-3/10">
        <DateSwitcher
          changeDate={setCurrentDate}
          currentDate={currentDate}
        />
      </div>
    </div>

    <AddTimeTrackingEntry
      canEditTimeTracking={canEditTimeTracking}
      barberId={barberId}
      currentDate={currentDate}
      entries={entries}
    />
    <div className="c-table-card u-table-layout-fixed u-mt">
      <div className="c-table-card__head u-mb">
        <div className="c-table-card__cell c-label u-1/20" />
        <div className="c-table-card__cell c-label u-1/10">
          Started
        </div>
        <div className="c-table-card__cell c-label u-1/10">
          hh/mm
        </div>
        <div className="c-table-card__cell c-label u-1/20" />
        <div className="c-table-card__cell u-1/10" display-if={!extendedHourlyWages} />
        <div className="c-table-card__cell c-label u-1/10">
          Ended
        </div>
        <div className="c-table-card__cell c-label u-1/10">
          hh/mm
        </div>
        <div className="c-table-card__cell u-1/10" display-if={!extendedHourlyWages} />
        <div className="c-table-card__cell c-label u-1/10 u-text-center">
          Duration
        </div>
        <div className="c-table-card__cell c-label u-2/10" display-if={!!extendedHourlyWages}>
          <span>Role</span>
        </div>
        <div className="c-table-card__cell c-label u-2/10" />
      </div>

      {entries.map(entry => (
        <EditTimeTrackingEntry
          key={entry.id}
          entry={entry}
          currentDate={currentDate}
          canEditTimeTracking={canEditTimeTracking}
        />
      ))}
    </div>
    <div className="c-heading u-mt u-mb-">Total time: <span className="u-type--bold">{totalTime}</span></div>
  </div>
);

EditTimeTracking.propTypes = {
  setCurrentDate: PropTypes.func.isRequired,
  currentDate: PropTypes.string.isRequired,
  extendedHourlyWages: PropTypes.bool.isRequired,
  totalTime: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  barberId: PropTypes.string.isRequired,
  canEditTimeTracking: PropTypes.bool.isRequired,
};
EditTimeTracking.defaultProps = {};

export default EditTimeTracking;
